import React, { useState } from 'react';
import './Landing.css';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaWhatsapp,
} from 'react-icons/fa';
import logo from '../assets/logo.png';

export default function Landing() {
  const [showPhoneOptions, setShowPhoneOptions] = useState(false);
  const [showMapOptions, setShowMapOptions] = useState(false);

  const address =
    '190 Woodlands Ind. Park E5 #06-12 WOODLANDS BIZHUB 757516';
  const mapsQuery = encodeURIComponent(address);
  const wazeQuery = 'https://waze.com/ul?ll=1.4521,103.7922&navigate=yes';
  const whatsappNumber = '6589898221';

  return (
    <div className="landing-portrait pryce-theme">
      {/* HEADER */}
      <div className="header">
        <img src={logo} alt="Pryce Technologies" className="logo-top-left" />
      </div>

      {/* IDENTITY */}
      <div className="identity">
        <h2>DOMINIC LIM</h2>
        <p className="title">Director</p>
      </div>

      {/* PHONE */}
      <div
        className="info-card glow"
        onClick={() => setShowPhoneOptions(!showPhoneOptions)}
      >
        <FaPhoneAlt />
        <span>+65 8989 8221</span>
      </div>

      {showPhoneOptions && (
        <div className="action-row">
          <a href="tel:+6589898221" className="action-btn primary">
            Call
          </a>
          <a
            href={`https://wa.me/${whatsappNumber}`}
            className="action-btn whatsapp"
          >
            <FaWhatsapp />
            WhatsApp
          </a>
        </div>
      )}

      {/* EMAIL */}
      <a className="info-card glow" href="mailto:dominic@prycetech.sg">
        <FaEnvelope />
        <span>dominic@prycetech.sg</span>
      </a>

      {/* WEBSITE */}
      <a className="info-card glow" href="https://www.prycetech.com">
        <FaGlobe />
        <span>www.prycetech.com</span>
      </a>

      {/* ADDRESS */}
      <div
        className="info-card glow multiline"
        onClick={() => setShowMapOptions(!showMapOptions)}
      >
        <FaMapMarkerAlt />
        <span>
          190 Woodlands Ind. Park E5
          <br />
          #06-12 WOODLANDS BIZHUB 757516
        </span>
      </div>

      {showMapOptions && (
        <div className="action-row">
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${mapsQuery}`}
            className="action-btn"
          >
            Google Maps
          </a>
          <a href={wazeQuery} className="action-btn">
            Waze
          </a>
        </div>
      )}

      {/* SERVICES */}
      <div className="services">
        <p>Digital Signage Solutions</p>
        <p>Custom Web/App Development</p>
        <p>Cloud Infrastructure & Services</p>
        <p>CCTV Installations & Services</p>
      </div>

      {/* FOOTER */}
      <div className="footer">
        Pryce Technologies Pte Ltd
      </div>
    </div>
  );
}
